<template>
	<screen class="designations-view">
		<template slot="header">
			<ui-header type="dark" @click="onBack">
				<h2 slot="title">Campaigns</h2>
			</ui-header>
		</template>
		<div class="designations-items">
			<div
				class="designation-item"
				:key="designation.id"
				v-for="designation in designations"
				@click="selectDesignation(designation)"
			>
				<span class="title">{{ designation.title }}</span>
			</div>
		</div>
	</screen>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UiHeader from '../../ui/Header'
import Screen from '../../ui/Screen'

export default {
	name: 'designations-view',
	components: { Screen, UiHeader },
	computed: {
		...mapState({
			designations: ({ institutionDetail }) =>
				institutionDetail.designations,
			home: ({ home }) => home.item
		})
	},
	methods: {
		...mapActions(['getDesignations', 'pickDesignation']),
		onBack() {
			this.navigate({ name: 'home' }, 'back')
		},
		selectDesignation(designation) {
			this.pickDesignation(designation.id)
				.then(() => {
					return this.$swal(
						'Success',
						'Your campaign has been set to ' +
							designation.title +
							'.'
					)
				})
				.then(() => {
					this.onBack()
				})
		}
	},
	mounted() {
		if (!this.home.institution) {
			this.navigate({ name: 'home' }, 'back')
		}
		this.getDesignations(this.home.institution.id)
	}
}
</script>

<style lang="scss">
.designations-view {
	background: $bone;
	overflow: hidden;
	position: relative;
	.designations-items {
		background: $white;
		margin: 10px -25px 0px;
		position: relative;
		padding: 10px 20px 20px;
		z-index: 10;
		border-radius: 14px;
		box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.15);
		@media screen and (max-width: 480px) {
			margin-left: -15px;
			margin-right: -15px;
		}
		.designation-item {
			padding: 15px 10px;
			display: flex;
			border-bottom: 1px solid $light-grey;
			cursor: pointer;
			text-decoration: none;
			color: $blue;
			&:last-child {
				border-bottom: 0px;
			}
			.title {
				color: #111;
				font-weight: 400 !important;
				font-size: 1rem !important;
			}
		}
		.settings-section {
			margin-bottom: 20px;
		}
	}
}
</style>
